import {
  edrOptions, FilterFields,
  GridType,
  operators,
  ruleFields,
  RuleType,
  Targets,
  Type,
  xdrOptions,
} from '../types';

export function convertRuleFromFrontendToBackendFormat(
  frontendRule: any,
  gridType: GridType,
  areAutomaticActionsAvailable: boolean
): any {
  const backendRule: any = {
      companyId: frontendRule.companyId,
      name: frontendRule.name,
      details: frontendRule.details ? frontendRule.details : '',
      tags: frontendRule.tags ? frontendRule.tags : [],
      query: RuleType.YARA === frontendRule.type
        ? { yara: frontendRule.query.yara }
        : convertRuleQueryFromFrontendToBackendFormat(frontendRule.query),
      type: frontendRule.type,
      status: frontendRule.status,
      ruleType: checkRuleCriteriaTypes(frontendRule, gridType) ,
    };

    if (frontendRule.targets.type === Targets.COMPANIES) {
      backendRule.targets = { companiesIds:  frontendRule.targets.companiesIds };
    } else if (frontendRule.targets.type === Targets.ENDPOINT) {
      backendRule.targets = { endpointTags: frontendRule.targets.endpointTags };
    } else {
      backendRule.targets = { companyId: frontendRule.targets.companyId };
    }

  if (frontendRule._id) {
    backendRule._id = frontendRule._id;
  }

  if (GridType.DETECTION === gridType) {
    backendRule.severity = frontendRule.severity;
    backendRule.generateRca = frontendRule.generateRca;

    if (RuleType.BASIC === frontendRule.type) {
      backendRule.enableAutomaticActions = frontendRule.enableAutomaticActions;
      backendRule.automaticActions = frontendRule.automaticActions;
    }
  }

  return prepareRuleForBackendProcessing(backendRule, gridType, areAutomaticActionsAvailable);
}

export function checkRuleCriteriaTypes(rule, gridType) {
  if (rule.type !== RuleType.BASIC || gridType === GridType.DETECTION) {
    return null;
  }

  let hasXdrRules = false;
  let hasEdrRules = false;

  const queryRules = rule.query.rules;
  const xdrAvailableOptions = xdrOptions[rule.query.type] ?? [];
  const edrAvailableOptions = edrOptions[rule.query.type] ?? [];
  queryRules.forEach(rule => {
    if (xdrAvailableOptions.includes(rule.criteriaValue)) {
      hasXdrRules = true;
    }
    if (edrAvailableOptions.includes(rule.criteriaValue)) {
      hasEdrRules = true;
    }
  });

  if (hasEdrRules && hasXdrRules) {
    return Type.EDR_XDR;
  }

  if (hasXdrRules) {
    return Type.XDR;
  }

  if (hasEdrRules) {
    return Type.EDR;
  }

  return Type.COMMON;
}

function convertRuleQueryFromFrontendToBackendFormat(frontendQuery: any): any {
  const backendQueryRules = new Array<any>();
  for (const frontendQueryRule of frontendQuery.rules) {
    if (frontendQueryRule.criteriaValue === FilterFields.ALERT_NAME) {
      frontendQuery.detection = frontendQueryRule.inputValue;
    } else {
      const backendQueryRule = {
        field: ruleFields[frontendQuery.type][frontendQueryRule.criteriaValue],
        relation: operators[frontendQueryRule.operatorValue],
        value: Array.isArray(frontendQueryRule.inputValue)
               ? frontendQueryRule.inputValue
               : [frontendQueryRule.inputValue],
      };
      if (backendQueryRules.length) {
        backendQueryRule['operator'] = 'AND';
      }
      backendQueryRules.push(backendQueryRule);
    }
  }
  return {
    type: frontendQuery.type,
    detection: frontendQuery.detection,
    rules: backendQueryRules,
  };
}

export function prepareRuleForBackendProcessing(
  backendRule: any,
  gridType: GridType,
  areAutomaticActionsAvailable: boolean
): any {
  if (GridType.DETECTION === gridType && RuleType.BASIC === backendRule.type) {
    if (areAutomaticActionsAvailable) {
      backendRule.enableAutomaticActions = backendRule.enableAutomaticActions ?? false;
      backendRule.automaticActions = backendRule.automaticActions ?? [];
    } else {
      backendRule.enableAutomaticActions = false;
      backendRule.automaticActions = [];
    }
  }

  return backendRule;
}
